export default __webpack_public_path__ + "static/media/CharityWatch_Seal_RGB_WEB_hi-res.1727a26f.png";